{
  "appName": "VynaEMR",
  "appTagline": "เวชระเบียนอิเล็กทรอนิกส์เพื่อภูมิภาคเอเชียแปซิฟิก",
  "developedByLabel": "พัฒนาโดย",
  "loading": "กำลังโหลด...",
  "save": "บันทึก",
  "cancel": "ยกเลิก",
  "delete": "ลบ",
  "edit": "แก้ไข",
  "create": "สร้าง",
  "search": "ค้นหา",
  "filter": "กรอง",
  "actions": "การดำเนินการ",
  "confirm": "ยืนยัน",
  "back": "กลับ",
  "next": "ถัดไป",
  "previous": "ก่อนหน้า",
  "submit": "ส่ง",
  "reset": "รีเซ็ต",
  "close": "ปิด",
  "yes": "ใช่",
  "no": "ไม่",
  "ok": "ตกลง",
  "error": "ข้อผิดพลาด",
  "success": "สำเร็จ",
  "warning": "คำเตือน",
  "info": "ข้อมูล",
  "validation": {
    "required": "จำเป็นต้องกรอกข้อมูลนี้",
    "invalidEmail": "ที่อยู่อีเมลไม่ถูกต้อง",
    "invalidPhone": "หมายเลขโทรศัพท์ไม่ถูกต้อง",
    "invalidDate": "วันที่ไม่ถูกต้อง",
    "minLength": "ต้องมีอย่างน้อย {{min}} ตัวอักษร",
    "maxLength": "ใส่ได้สูงสุด {{max}} ตัวอักษร",
    "passwordMismatch": "รหัสผ่านไม่ตรงกัน"
  },
  "form": {
    "fieldRequired": "กรุณากรอก{{field}}",
    "selectOption": "กรุณาเลือกตัวเลือก",
    "discardConfirm": "ละทิ้งการเปลี่ยนแปลงที่ยังไม่บันทึก?",
    "unsavedChanges": "คุณมีการเปลี่ยนแปลงที่ยังไม่บันทึก",
    "mustBeNonNegativeInteger": "{{field}} ต้องเป็นจำนวนเต็มตั้งแต่ 0 ขึ้นไป",
    "mustBeNonNegativeNumber": "{{field}} ต้องเป็นตัวเลขตั้งแต่ 0 ขึ้นไป"
  },
  "unsavedChanges": {
    "title": "การเปลี่ยนแปลงที่ยังไม่ได้บันทึก",
    "body": "คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก ต้องการออกจากหน้านี้หรือไม่? การเปลี่ยนแปลงจะสูญหาย",
    "stay": "อยู่ต่อ",
    "leave": "ออก"
  },
  "messages": {
    "saveSuccess": "บันทึกการเปลี่ยนแปลงสำเร็จ",
    "saveError": "ไม่สามารถบันทึกการเปลี่ยนแปลงได้",
    "deleteConfirm": "คุณแน่ใจหรือไม่ว่าต้องการลบรายการนี้?",
    "deleteSuccess": "ลบรายการสำเร็จ",
    "deleteError": "ไม่สามารถลบรายการได้",
    "networkError": "เกิดข้อผิดพลาดของเครือข่าย กรุณาตรวจสอบการเชื่อมต่อ",
    "serverError": "เกิดข้อผิดพลาดของเซิร์ฟเวอร์ กรุณาลองอีกครั้งในภายหลัง",
    "unauthorized": "คุณไม่มีสิทธิ์ดำเนินการนี้"
  },
  "dateFormat": {
    "short": "DD/MM/YYYY",
    "long": "D MMMM YYYY",
    "withTime": "DD/MM/YYYY HH:mm",
    "timeOnly": "HH:mm"
  },
  "demo": {
    "warning": "นี่คือเดโม VynaEMR — กรุณาอย่ากรอกข้อมูลผู้ป่วยจริง (PHI)"
  },
  "network": {
    "offline": "คุณออฟไลน์อยู่ ข้อมูลทางคลินิกอาจไม่ถูกบันทึก"
  },
  "permissionDenied": {
    "title": "ปฏิเสธการเข้าถึง",
    "body": "คุณไม่มีสิทธิ์{{action}}",
    "genericBody": "คุณไม่มีสิทธิ์ดูทรัพยากรนี้",
    "requiredPermission": "สิทธิ์ที่ต้องการ: {{name}}",
    "contactAdmin": "หากคุณเชื่อว่านี่เป็นข้อผิดพลาด กรุณาติดต่อผู้ดูแลระบบ",
    "requiresPermissionCode": "ต้องการสิทธิ์: {{code}}",
    "requiresLabel": "ต้องการ {{label}}",
    "requiresLabelWithRoles": "ต้องการ {{label}} (ถือโดย: {{roles}})",
    "insufficient": "สิทธิ์ไม่เพียงพอ"
  },
  "skipToContent": "ข้ามไปยังเนื้อหา",
  "openMenu": "เปิดเมนู",
  "topBar": {
    "searchPlaceholder": "ค้นหาผู้ป่วย (MRN, ชื่อ, ID)...",
    "recentPatients": "ผู้ป่วยล่าสุด",
    "searching": "กำลังค้นหา...",
    "noPatientsFound": "ไม่พบผู้ป่วย กด Enter เพื่อค้นหา",
    "notifications": "การแจ้งเตือน",
    "selectFacility": "เลือกสถานพยาบาล",
    "allFacilities": "สถานพยาบาลทั้งหมด",
    "facilityLabel": "สถานพยาบาล {{id}}",
    "activeDepartment": "ปฏิบัติงานที่",
    "selectDepartment": "เลือกแผนกที่ปฏิบัติงาน",
    "noDepartmentSelected": "เลือกแผนก",
    "departmentLabel": "แผนก {{id}}",
    "departmentSwitchFailed": "สลับไม่สำเร็จ"
  },
  "theme": {
    "toggle": "สลับธีม",
    "light": "สว่าง",
    "dark": "มืด",
    "system": "ระบบ",
    "current": "ธีม: {{name}}"
  },
  "appVersionLabel": "VynaEMR v{{version}}",
  "footerCopyright": "© {{year}}",
  "footerHealthOperational": "ใช้งานได้",
  "footerHealthIssue": "ปัญหาการเชื่อมต่อ",
  "dobLabel": "วันเกิด {{date}}",
  "pagination": {
    "previous": "ก่อนหน้า",
    "next": "ถัดไป",
    "pageOf": "หน้า {{current}} จาก {{total}}",
    "showing": "แสดง {{from}} ถึง {{to}} จาก {{total}}",
    "loadMore": "โหลดเพิ่มเติม"
  },
  "table": {
    "empty": "ไม่มีข้อมูล",
    "loading": "กำลังโหลด..."
  },
  "cdsAlert": {
    "severity": {
      "info": "ข้อมูล",
      "warning": "คำเตือน",
      "critical": "วิกฤต"
    },
    "overridden": "ถูกแทนที่",
    "acknowledged": "รับทราบแล้ว",
    "justificationPlaceholder": "ป้อนเหตุผลในการอนุมัติข้าม...",
    "submit": "ส่ง",
    "acknowledge": "รับทราบ",
    "override": "แทนที่",
    "regionAria": "การแจ้งเตือนระบบสนับสนุนการตัดสินใจทางคลินิก (CDS)",
    "acknowledgeFailed": "ไม่สามารถบันทึกการรับทราบได้ — ยังไม่ได้บันทึก โปรดลองอีกครั้ง",
    "overrideFailed": "ไม่สามารถบันทึกการแทนที่ได้ — ยังไม่ได้บันทึก โปรดลองอีกครั้ง",
    "addressedCount_one": "จัดการแล้ว {{count}} รายการ",
    "addressedCount_other": "จัดการแล้ว {{count}} รายการ"
  },
  "components": {
    "printButton": {
      "defaultLabel": "พิมพ์"
    },
    "codeSearch": {
      "searchPlaceholder": "ค้นหารหัส...",
      "clearAriaLabel": "ล้างการเลือก",
      "noCodesFound": "ไม่พบรหัส"
    },
    "demographicPicker": {
      "addPlaceholder": "เพิ่ม…",
      "loading": "กำลังโหลด…",
      "noneRecorded": "ไม่มีการบันทึก",
      "removeAriaLabel": "ลบ {{value}}",
      "unavailable": "ไม่มีรายการค่าให้เลือก",
      "unavailableHint": "ไม่สามารถโหลดรายการค่าได้ ค่าที่มีอยู่ยังคงเดิมและจะถูกบันทึก",
      "uncodedBadge": "ไม่มีรหัส",
      "uncodedTitle": "บันทึกก่อนมีค่าแบบมีรหัส สามารถลบได้ แต่เพิ่มกลับไม่ได้"
    }
  },
  "pages": {
    "accessDenied": {
      "title": "การเข้าถึงถูกปฏิเสธ",
      "httpStatus": "HTTP 403",
      "body": "คุณไม่มีสิทธิ์ดูหน้านี้",
      "attemptedLabel": "พยายามเข้าถึง:",
      "requiredPermissionLabel": "สิทธิ์ที่จำเป็น:",
      "typicallyHeldByLabel": "โดยทั่วไปสิทธิ์นี้ถือโดย:",
      "signedInAs": "เข้าสู่ระบบในชื่อ",
      "contactAdminHelp": "หากคุณเชื่อว่าเป็นข้อผิดพลาด โปรดติดต่อผู้ดูแลระบบหรือหัวหน้าแผนกเพื่อขอบทบาทที่จำเป็น",
      "goBack": "ย้อนกลับ",
      "dashboard": "แดชบอร์ด",
      "contact": "ติดต่อ"
    },
    "notificationInbox": {
      "title": "การแจ้งเตือน",
      "markAllRead": "ทำเครื่องหมายอ่านทั้งหมด",
      "loading": "กำลังโหลดการแจ้งเตือน…",
      "errorState": "โหลดการแจ้งเตือนไม่สำเร็จ",
      "emptyState": "ไม่พบการแจ้งเตือน",
      "ariaFilterStatus": "กรองตามสถานะ",
      "ariaFilterPriority": "กรองตามระดับความสำคัญ",
      "ariaFilterType": "กรองตามประเภท",
      "filterStatus": {
        "all": "ทั้งหมด",
        "unread": "ยังไม่ได้อ่าน",
        "read": "อ่านแล้ว"
      },
      "filterPriority": {
        "allLabel": "ทุกระดับความสำคัญ",
        "critical": "วิกฤต",
        "high": "สูง",
        "normal": "ปกติ",
        "low": "ต่ำ"
      },
      "filterType": {
        "allLabel": "ทุกประเภท"
      },
      "notificationType": {
        "criticalResult": "ผลตรวจวิกฤต",
        "orderUpdate": "อัปเดตคำสั่งแพทย์",
        "appointmentReminder": "แจ้งเตือนนัดหมาย",
        "systemAlert": "แจ้งเตือนระบบ",
        "cdsAlert": "แจ้งเตือนการสนับสนุนการตัดสินใจทางคลินิก",
        "result": "ผลการตรวจ",
        "handoffAssigned": "การส่งมอบเวร"
      },
      "toasts": {
        "allMarkedRead": "ทำเครื่องหมายการแจ้งเตือนทั้งหมดเป็นอ่านแล้ว",
        "markAllReadFailed": "ทำเครื่องหมายอ่านทั้งหมดไม่สำเร็จ",
        "markReadFailed": "ทำเครื่องหมายอ่านไม่สำเร็จ"
      }
    },
    "entityResolver": {
      "invalidId": "ลิงก์ไม่ถูกต้อง",
      "notFound": "ไม่พบ หรือคุณไม่มีสิทธิ์เข้าถึง"
    }
  },
  "license": {
    "evalBanner": "Evaluation license: {{count}} days left.",
    "graceBanner": "License issue: service continues for {{count}} more hours.",
    "expiringBanner": "License expires soon: {{count}} days left. Renew now to avoid service refusal.",
    "saasUnkeyedBanner": "Organization license not installed. Premium modules are open during rollout.",
    "saasUnverifiableBanner": "Organization license cannot be verified. Premium modules are open; contact support.",
    "expiredBanner": "License expired. Requests are being refused.",
    "invalidBanner": "License invalid. Requests are being refused.",
    "viewLicense": "View license"
  },
  "wsDown": {
    "title": "ไม่สามารถอัปเดตแบบสดได้",
    "body": "ผลและคำเตือนใหม่จะไม่มาถึงโดยอัตโนมัติจนกว่าการเชื่อมต่อจะกลับมา",
    "authBody": "เซสชันของคุณหมดอายุแล้ว กรุณาเข้าสู่ระบบอีกครั้งเพื่อกู้คืนการอัปเดตแบบสด",
    "retry": "ลองอีกครั้ง",
    "login": "เข้าสู่ระบบ"
  }
}
